import type { Rule } from "../types";

export const recolorYellowToBlue: Rule = {
  id: "system.recolor-yellow-to-blue",
  name: "Yellow → Blue",
  description: "Recolor cells with #FFFF00 fill to #0000FF.",
  enabled: true,
  source: "system",
  match: { fillColor: "#FFFF00" },
  apply: { fillColor: "#0000FF" },
};
